import { B as BookSeries, a as BookSeriesItemsForm, b as BookSeriesItem } from "./book-series.643ec7dc.chunk.js";
import { a as formatMoney } from "./g-utils.8c594119.chunk.js";
function _getQueryString(obj, prefix) {
  const pairs = [];
  for (let key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    const value = obj[key];
    const enkey = encodeURIComponent(key);
    let pair;
    if (typeof value === "object") {
      if (Array.isArray(value)) {
        pair = value.map((item) => {
          return _getQueryString(
            item,
            prefix ? `${prefix}[${enkey}][]` : `${enkey}[]`
          );
        }).join("&");
      } else {
        pair = _getQueryString(value, prefix ? `${prefix}[${enkey}]` : enkey);
      }
    } else {
      pair = (prefix ? `${prefix}[${enkey}]` : enkey) + "=" + encodeURIComponent(value);
    }
    pairs.push(pair);
  }
  return pairs.join("&");
}
async function suggest(params, renderSelectors) {
  let requestResponse;
  return fetch(
    window.Shopify.routes.root + `search/suggest?${_getQueryString(params)}`
  ).then((response) => {
    requestResponse = response;
    return response.text();
  }).then((text) => {
    if (!requestResponse.ok) {
      throw new Error(`${requestResponse.status}: ${text}`);
    }
    renderSelectors.forEach((renderSelector) => {
      const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector(renderSelector).innerHTML;
      document.querySelector(renderSelector).innerHTML = resultsMarkup;
    });
  }).catch((error) => {
    console.error(error);
  });
}
async function addItem(variantId, quantity = 1, subscriptionPlanId = null, customProperties = {}) {
  const lineItem = {
    id: variantId,
    quantity,
    properties: customProperties
  };
  if (subscriptionPlanId) {
    lineItem.selling_plan = subscriptionPlanId;
  }
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items: [lineItem] })
    });
    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "An error occurred while adding the product to the cart");
    }
    console.log("Product added to cart:", data);
    return data;
  } catch (error) {
    console.error("Error adding product to cart:", error.message);
    return false;
  }
}
async function addItems(items) {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ items })
    });
    const data = await response.json();
    if (response.ok) {
      console.log("Products added to cart:", data);
    } else {
      throw new Error(
        data.message || "An error occurred while adding the products to the cart"
      );
    }
  } catch (error) {
    console.error("Error adding products to cart:", error.message);
  }
}
async function getAll() {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    });
    const data = await response.json();
    if (response.ok) {
      console.log("Cart contents:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while retrieving the cart"
      );
    }
  } catch (error) {
    console.error("Error retrieving cart:", error.message);
    throw error;
  }
}
async function updateItem(variantId, quantity) {
  try {
    const updates = {
      [variantId]: quantity
    };
    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ updates })
      }
    );
    const data = await response.json();
    if (response.ok) {
      console.log("Cart updated:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while updating the cart"
      );
    }
  } catch (error) {
    console.error("Error updating cart:", error.message);
    throw error;
  }
}
async function updateItems(updates) {
  try {
    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ updates })
      }
    );
    const data = await response.json();
    if (response.ok) {
      console.log("Cart updated:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while updating the cart"
      );
    }
  } catch (error) {
    console.error("Error updating cart:", error.message);
    throw error;
  }
}
async function updateAttributes(attributes) {
  try {
    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ attributes })
      }
    );
    const data = await response.json();
    if (response.ok) {
      console.log("Cart updated:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while updating the cart"
      );
    }
  } catch (error) {
    console.error("Error updating cart:", error.message);
    throw error;
  }
}
async function changeItem(variantId, quantity, subscriptionPlanId = null, customProperties = {}) {
  try {
    const change = {
      id: variantId,
      quantity,
      properties: customProperties
    };
    if (subscriptionPlanId) {
      change.selling_plan = subscriptionPlanId;
    }
    const response = await fetch(
      window.Shopify.routes.root + "cart/change.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(change)
      }
    );
    const data = await response.json();
    if (response.ok) {
      console.log("Cart item changed:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while changing the cart item"
      );
    }
  } catch (error) {
    console.error("Error changing cart item:", error.message);
    throw error;
  }
}
async function clear() {
  try {
    const response = await fetch(window.Shopify.routes.root + "cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      }
    });
    const data = await response.json();
    if (response.ok) {
      console.log("Cart cleared:", data);
      return data;
    } else {
      throw new Error(
        data.message || "An error occurred while clearing the cart"
      );
    }
  } catch (error) {
    console.error("Error clearing cart:", error.message);
    throw error;
  }
}
const cart = {
  addItem,
  addItems,
  getAll,
  updateItem,
  updateItems,
  updateAttributes,
  changeItem,
  clear
};
const shopifyAPI = {
  suggest,
  cart
};
class SeriesPage extends BookSeries {
  constructor() {
    super();
  }
  _updateContent(html) {
    const seriesDescriptions = this.querySelectorAll(".js-series-description");
    const seriesItems = this.querySelector(".js-series-items");
    const totalPriceBlock = this.querySelector(".js-total-price-block");
    const totalPrice = this.querySelector(".js-total-price");
    const booksCount = this.querySelector(".js-books-count");
    const seriesBreadcrumb = this.querySelector(".js-series-breadcrumb");
    const ATCBtn = this.querySelector(".js-atc-button");
    let newDescription = this._sectionBatches[0].querySelector(".js-series-description");
    let newseriesBreadcrumb = this._sectionBatches[0].querySelector(".js-series-breadcrumb");
    let newSeriesItems = document.createElement("DIV");
    let newTotalPrice = 0;
    let newBooksCount = 0;
    for (const batch of this._sectionBatches) {
      const curSeriesItems = batch.querySelector(".js-series-items").innerHTML;
      const curTotalPrice = parseInt(batch.querySelector(".js-total-price").innerHTML);
      const curBooksCount = parseInt(batch.querySelector(".js-books-count").innerHTML);
      newSeriesItems.insertAdjacentHTML("beforeend", curSeriesItems);
      newTotalPrice += curTotalPrice;
      newBooksCount += curBooksCount;
    }
    seriesDescriptions.forEach((description) => description.innerHTML = newDescription.innerHTML);
    seriesItems.innerHTML = newSeriesItems.innerHTML;
    if (newTotalPrice > 0) {
      totalPrice.innerHTML = formatMoney(newTotalPrice);
      totalPriceBlock.classList.remove("jc-hidden");
      if (ATCBtn)
        ATCBtn.disabled = false;
    } else {
      totalPriceBlock.classList.add("jc-hidden");
      if (ATCBtn)
        ATCBtn.disabled = true;
    }
    const totalBooksCountEls = this.querySelectorAll(".js-total-books-count");
    totalBooksCountEls.forEach((el) => el.innerHTML = this._retailCollection.productIds.length);
    booksCount.innerHTML = newBooksCount;
    seriesBreadcrumb.innerHTML = newseriesBreadcrumb.innerHTML;
  }
  async _updateQuantities() {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    try {
      const cart2 = await shopifyAPI.cart.getAll();
      const items = cart2.items;
      const booksCountEl = this.querySelector(".js-books-count");
      const totalPriceBlockEl = this.querySelector(".js-total-price-block");
      const totalPriceEl = this.querySelector(".js-total-price");
      const itemEls = this.querySelectorAll("series-page-item");
      const ATCBtn = this.querySelector(".js-atc-button");
      itemEls.forEach((item) => {
        item.updateQuantities(items);
      });
      let newBooksCount = 0;
      let newTotalPrice = 0;
      Array.from(itemEls).filter((item) => item.getAttribute("aria-disabled") !== "true").forEach((item) => {
        newBooksCount++;
        newTotalPrice += item.price;
      });
      booksCountEl.textContent = newBooksCount;
      totalPriceEl.textContent = formatMoney(newTotalPrice);
      if (ATCBtn && newTotalPrice > 0) {
        totalPriceBlockEl.classList.remove("jc-hidden");
        ATCBtn.disabled = false;
      } else {
        ATCBtn.disabled = true;
        totalPriceBlockEl.classList.add("jc-hidden");
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    }
  }
  _initStickyAside() {
    const announcementBar = document.querySelector(".js-announcement-bar");
    const header = document.querySelector("#shopify-section-header");
    const stickyElement = this.querySelector(".js-sticky-aside");
    var endScroll, currPos = window.scrollY, screenHeight = window.innerHeight, stickyElementHeight = stickyElement.offsetHeight;
    let topGap = 0, bottomGap = 0;
    if (header) {
      topGap = header.offsetHeight;
    }
    if (announcementBar) {
      topGap += announcementBar.offsetHeight;
    }
    stickyElement.style.setProperty("--position-top", topGap + `px`);
    function positionStickySidebar() {
      endScroll = window.innerHeight - stickyElement.offsetHeight - bottomGap;
      let stickyElementTop = parseInt(
        stickyElement.style.getPropertyValue("--position-top").replace(`px;`, ``)
      );
      let stickyElementNewTop;
      if (stickyElementHeight + topGap + bottomGap > screenHeight) {
        let scrollDelta = currPos - window.scrollY;
        if (scrollDelta > 0) {
          stickyElementNewTop = Math.min(stickyElementTop + scrollDelta, topGap);
        } else {
          stickyElementNewTop = Math.max(stickyElementTop + scrollDelta, endScroll);
        }
      } else {
        stickyElementNewTop = topGap;
      }
      stickyElement.style.setProperty("--position-top", stickyElementNewTop + `px`);
      currPos = window.scrollY;
    }
    function updateSticky() {
      screenHeight = window.innerHeight;
      stickyElementHeight = stickyElement.offsetHeight;
      positionStickySidebar();
    }
    window.addEventListener(`resize`, () => {
      topGap = header.offsetHeight;
      currPos = window.scrollY;
      updateSticky();
    });
    document.addEventListener(`scroll`, updateSticky, {
      capture: true,
      passive: true
    });
  }
  connectedCallback() {
    super.connectedCallback();
    document.documentElement.addEventListener("cart:rerender", (e) => {
      clearTimeout(this.cartTimoutId);
      this.cartTimoutId = setTimeout(this._updateQuantities.bind(this), 1e3);
    });
    this._initStickyAside();
  }
}
class SeriesPageItemsForm extends BookSeriesItemsForm {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();
  }
}
class SeriesPageItem extends BookSeriesItem {
  constructor() {
    super();
    this._addToCartBtn = this.querySelectorAll(".js-add-to-cart");
    this._variantsJSON = JSON.parse(this.querySelector(".js-inventory-quantities").innerHTML);
    this._priceEl = this.querySelector(".js-price");
    this._compareAtPriceEl = this.querySelector(".js-compare-at-price");
  }
  connectedCallback() {
    this._addToCartBtn.forEach((el) => {
      el.addEventListener("click", this._addToCart.bind(this));
    });
  }
  async _addToCart(e) {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: this.variantId,
              properties: {
                _wasAddedFromBuySeries: true,
                Auteur: this.author
              }
            }
          ],
          sections: window.jollyVariables.cartSectionId
        })
      });
      if (response.ok) {
        const json = await response.json();
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = json.sections[window.jollyVariables.cartSectionId];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:rerender", {
            detail: {
              sectionEl: tempDiv.children[0],
              cart: { item_count: json.item_count, items: json.items },
              scrollToTop: true,
              new_items_ids: [this.variantId]
            }
          })
        );
        window.jollyFunctions.klaviyoTrackAddToCart(this.atcKlaviyoEventData);
      }
    } catch (error) {
      console.error(error);
    } finally {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    }
  }
  updateQuantities(cartItems) {
    var _a;
    for (let key of Object.keys(this._variantsJSON)) {
      const inCartCount = ((_a = cartItems.find((item) => item.variant_id == key)) == null ? void 0 : _a.quantity) || 0;
      this._variantsJSON[key].availableQnt = this._variantsJSON[key].inventoryQnt - inCartCount;
    }
    this._checkAvailability();
  }
  _checkAvailability() {
    let available = false;
    for (let variantId of Object.keys(this._variantsJSON)) {
      if (this._variantsJSON[variantId].availableQnt > 0) {
        this.variantId = variantId;
        available = true;
        break;
      }
    }
    if (!available) {
      this.disable();
    } else {
      this.enable();
    }
  }
  set variantId(id) {
    super.variantId = id;
    const price = this._variantsJSON[id].price;
    const compareAtPrice = this._variantsJSON[id].compareAtPrice;
    this._priceEl.innerHTML = formatMoney(price);
    this._compareAtPriceEl.innerHTML = formatMoney(compareAtPrice);
    if (compareAtPrice > price) {
      this._compareAtPriceEl.setAttribute("aria-hidden", false);
    } else {
      this._compareAtPriceEl.setAttribute("aria-hidden", true);
    }
  }
  get variantId() {
    return super.variantId;
  }
  get price() {
    return this._variantsJSON[this.variantId].price;
  }
}
window.customElements.define("series-page", SeriesPage);
window.customElements.define("series-page-items-form", SeriesPageItemsForm, {
  extends: "form"
});
window.customElements.define("series-page-item", SeriesPageItem);
//# sourceMappingURL=jc-bundle-series.js.map
